import type { MeetingStatus } from "@meeting-notes/shared";

const map: Record<MeetingStatus, { label: string; cls: string }> = {
  UPLOAD_PENDING: { label: "업로드 대기", cls: "bg-slate-700 text-slate-200" },
  UPLOADED: { label: "업로드 완료", cls: "bg-slate-700 text-slate-200" },
  TRANSCRIBING: { label: "전사 중", cls: "bg-amber-900/60 text-amber-200" },
  ANALYZING: { label: "분석 중", cls: "bg-indigo-900/60 text-indigo-200" },
  COMPLETED: { label: "완료", cls: "bg-emerald-900/60 text-emerald-200" },
  FAILED: { label: "실패", cls: "bg-red-900/60 text-red-200" },
};

export function StatusChip({ status }: { status: MeetingStatus }) {
  const m = map[status];
  return <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${m.cls}`}>{m.label}</span>;
}
